import { PROCESS_STEPS, COPY } from "../lib/_data";

export default function ProcessSteps() {
  const c = COPY.home.process || {};
  return (
    <section
      data-testid="process-section"
      className="bg-[#f9f6f0] py-20 md:py-32"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 lg:px-14">
        <div className="max-w-2xl mb-14 md:mb-20">
          <span className="text-xs tracking-[0.24em] uppercase font-bold text-[#c85a3c]" data-testid="process-eyebrow">
            {c.eyebrow || "The Process"}
          </span>
          <h2 className="font-display text-3xl md:text-5xl font-black text-[#2c2a29] leading-[1.05] mt-4" data-testid="process-heading">
            {c.title || "Three simple steps. Zero surprises."}
          </h2>
          <p className="mt-5 text-[#5c5855] leading-relaxed" data-testid="process-subhead">
            {c.subtitle || (
              "From your first message to the final handshake, we keep it clear, " +
              "respectful, and on schedule."
            )}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8 relative">
          {/* connecting dashed line — desktop only */}
          <div className="hidden md:block absolute top-14 left-[16%] right-[16%] border-t-2 border-dashed border-[#c85a3c]/30" />
          {PROCESS_STEPS.map((s, i) => (
            <div
              key={s.number}
              data-testid={`process-step-${i}`}
              className="relative bg-[#fffdf9] rounded-2xl p-8 border border-[#e5e0d8]"
            >
              <div className="w-14 h-14 rounded-full bg-[#c85a3c] text-[#fffdf9] font-display font-black text-xl flex items-center justify-center relative z-10 shadow-[0_10px_24px_rgba(200,90,60,0.35)]">
                {s.number}
              </div>
              <h3 className="mt-6 font-display text-xl md:text-2xl font-bold text-[#2c2a29]">
                {s.title}
              </h3>
              <p className="mt-3 text-[#5c5855] leading-relaxed text-[15px]">
                {s.body}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
